import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
// import { MsAdalAngular6Service } from 'microsoft-adal-angular6';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  isLoginFailed = false;
  isLoggedIn = false;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    // this.isLoggedIn = (this._adalSvc.userInfo) ? true : false;
    this.route.params.subscribe((params: any) => {
      this.isLoginFailed = params['isLoginFailed'] as boolean;
    });
  }

}
